/**
 * Handles the dealer form.
 * Validation and switching between the steps.
 */

define('libs/dealerlocator',['libs/dealerlocator.zipcodeform', 'libs/utilities.url', 'templates', 'mustache'], function(ZipcodeForm, _url, templates, Mustache) {

    'use strict';

    // executed when the Maps API is loaded.
    // needs to be in the global scope.
    window.maps_ready = function() {
        if (!window.GOOGLE_MAPS_LOADED) {
            window.GOOGLE_MAPS_LOADED = true;
            $(window).trigger('googlemaps.loaded');
        }
    };


    var SETTINGS = {
            zipcodeFormSelector: '#form-dealer-zipcode',
            dealerResultsSelector: '.dealer-search-result',
            dealerLookupSelector: '.dealer-lookup',
            listContainerSelector: '.dealer-list',
            showStoreButtonSelector: '.btn-maps',
            closeStoreButtonSelector: '.btn-overview',
            mapContainerSelector: '#dealer-map',
            overlaySelector: '.overlay',
            dealerZoomLevel: 17,
            fadeTime: 500,
            infoWindowTemplate: 'dealerinfowindow',
            markerIcons: {
                'Sunway dealer': fs_obj.icon_folder + 'marker.png',
                'Ster': fs_obj.icon_folder + 'marker-star.png',
                'SES': fs_obj.icon_folder + 'marker-exposure.png'
            },
            infoWindowClass: 'dealer-info-window'
        },

        getDealerLocatorMapSettings = function() {
            return {
                center: new google.maps.LatLng(52.090737, 5.121420),
                zoom: 9,
                mapTypeControl: false,
                panControl: false,
                streetViewControl: false,
                zoomControl: true,
//                zoomControlOptions: {
//                    position: google.maps.ControlPosition.TOP_LEFT,
//                    style: google.maps.ZoomControlStyle.DEFAULT
//                },
                scrollwheel: false,
                styles: [
                    {
                        stylers: [
                            //{visibility: 'on'},
                            //{lightness: -7}//,
                            //{saturation: 27},
                            //{gamma: .91}
                        ]
                    }
                ]
            };
        };


    var DealerMap = function(root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.root = root;

        // if a zipcode is provided in the url, use that.
        var zip = _url.getParameters().postcode;
        if (zip) {
            $(this.settings.dealerLookupSelector).hide();
            $(this.settings.overlaySelector).hide();
            this.zipCodeProvided = decodeURIComponent(zip).replace('+', '');
        }

        var zipcodeForm = $(this.settings.zipcodeFormSelector);
        this.zipCodeLookup = new ZipcodeForm(zipcodeForm[0], {
            listContainerSelector: '.dealer-search-result',
            template: 'dealerresults'
        });
        zipcodeForm.on(this.zipCodeLookup.EVENT.dealerlistBuild, this.showResults.bind(this));
        zipcodeForm.on(this.zipCodeLookup.EVENT.dealerlistBuild, this.setData.bind(this));
        zipcodeForm.on(this.zipCodeLookup.EVENT.dealerlistBuild, this.drawMarkers.bind(this));

        // load google maps.
        this.loadMapsAPI();

        if (window.GOOGLE_MAPS_LOADED) {
            this.start();
        } else {
            $(window).on('googlemaps.loaded', this.start.bind(this));
        }
    };

    DealerMap.prototype.start = function() {
        require(['infobox']);
        this.mapSettings = getDealerLocatorMapSettings();
        this.mapContainer = $(this.settings.mapContainerSelector);
        this.map = new google.maps.Map(this.mapContainer[0], this.mapSettings);

        this.root.on('click', this.settings.showStoreButtonSelector, this.handleStoreClick.bind(this));

        if (this.zipCodeProvided) {
            this.zipCodeLookup.field_zipcode.val(this.zipCodeProvided);
            this.zipCodeLookup.field_zipcode.trigger('change');
            this.zipCodeLookup.doLookup();
        }

        $(window).on('resize', this.fixResultLayout.bind(this));
    };

    /**
     * Load the Google Maps API.
     * When loaded, init the dealer finder.
     */
    DealerMap.prototype.loadMapsAPI = function() {
        window.MAPS_API_LOADED = true;
        var sensor = true,
            script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&callback=maps_ready&key=AIzaSyDJXScC9xflm0krwoyUcfV9hLWhyqgw1CA';
        document.body.appendChild(script);
    };

    DealerMap.prototype.handleStoreClick = function(event) {
        event.preventDefault();
        var storeID = $(event.currentTarget).data('id'),
            dealerData = this.dealerData[storeID];

        var data = $.extend({}, dealerData, {
            html: Mustache.to_html(templates[this.settings.infoWindowTemplate], dealerData),//'store info window html'
            markerIcons: this.settings.markerIcons
        });

        this.showStoreOnMap(data);
    };

    DealerMap.prototype.setData = function(event, data) {
        this.dealerData = (this.dealerData || []).concat(data.dealers);
    };

    /**
     * Draw markers for all the dealers on the map.
     * Zoom the map to just fit all the markers.
     */
    DealerMap.prototype.drawMarkers = function(event, data) {
        if (data.dealers) {
            var latLng = new google.maps.LatLng(Number(data.dealers[0].lat), Number(data.dealers[0].lng)),
                bounds = new google.maps.LatLngBounds(latLng, latLng);

            for (var i = 0; i < data.dealers.length; i++) {
                var dealerData = $.extend({}, data.dealers[i], {
                    markerIcons: this.settings.markerIcons
                });

                var marker = this.createMarker(dealerData);
                data.dealers[i].__marker = marker;

                bounds.extend(new google.maps.LatLng(Number(data.dealers[i].lat), Number(data.dealers[i].lng)));
            }

            this.map.fitBounds(bounds);
            this.map.setZoom(this.map.getZoom()); // Hier de zoom iets minder zetten -2
        }
    };

    DealerMap.prototype.handleStoreCloseClick = function(event) {
        event.preventDefault();

        this.closeInfoWindow(this.currentInfoWindow);

        // show dealer list
        //this.showResults();
    };

    DealerMap.prototype.showStoreOnMap = function(data) {
        // pan the map to the dealer location.
        this.map.panTo(new google.maps.LatLng(Number(data.lat), Number(data.lng)));
        this.map.setZoom(this.settings.dealerZoomLevel);

        this.currentMarker = data.__marker;

        // hide the dealer list.
        //this.hideResults();

        this.openInfoWindow(this.currentMarker, data);
    };

    DealerMap.prototype.createMarker = function(data) {
        var marker = new google.maps.Marker({
            title: data.company,
            position: new google.maps.LatLng(Number(data.lat), Number(data.lng)),
            map: this.map,
            icon: {
                // set the right icon for each store.
                url: data.markerIcons[data.storetype] || this.settings.markerIcons['Sunway dealer'],
                size: new google.maps.Size(38, 38),
                // The origin for this image is 0,0.
                origin: new google.maps.Point(0, 0),
                // The anchor for this image is the center bottom.
                anchor: new google.maps.Point(19, 19)
            }
        });

        google.maps.event.addListener(marker, 'click', function(data) {
            if (marker.infoWindow && marker.infoWindow.isOpen_) {
                this.closeInfoWindow(marker.infoWindow);
            } else {
                this.openInfoWindow(marker, data);
            }
        }.bind(this, data));

        return marker;
    };

    DealerMap.prototype.openInfoWindow = function(marker, data) {
        //close any open info window.
        if (this.currentInfoWindow && this.currentInfoWindow.isOpen_) {
            this.closeInfoWindow(this.currentInfoWindow);
        }

        if (!marker.infoWindow) {
            marker.infoWindow = this.createInfoWindow(Mustache.to_html(templates[this.settings.infoWindowTemplate], data));
        }
        // add or remove the overview-button class.
        var boxClass = this.settings.infoWindowClass + (this.resultsVisible ? '' : ' enable-overview-button');
        marker.infoWindow.setOptions({boxClass: boxClass});

        marker.infoWindow.open(this.map, marker);
        marker.infoWindow.isOpen_ = true;
        this.currentInfoWindow = marker.infoWindow;
        this.currentMarker = marker;
    };

    DealerMap.prototype.closeInfoWindow = function(infoWindow) {
        if (infoWindow) {
            infoWindow.close();
            infoWindow.isOpen_ = false;
        }
    };

    DealerMap.prototype.createInfoWindow = function(html) {
        var box = $(html);
        box.on('click', this.settings.closeStoreButtonSelector, this.handleStoreCloseClick.bind(this));

        var myOptions = {
            content: box[0],
            boxClass: this.settings.infoWindowClass,
            disableAutoPan: false,
            maxWidth: 0,
            pixelOffset: new google.maps.Size(-140, 0),
            zIndex: null,
            boxStyle: {
//                background: "url('tipbox.gif') no-repeat",
//                opacity: 0.75,
//                width: "280px"
            },
            infoBoxClearance: new google.maps.Size(1, 1),
            isHidden: false,
            pane: 'floatPane',
            enableEventPropagation: true
        };


        return new InfoBox(myOptions);
    };

    DealerMap.prototype.fixResultLayout = function() {
        var overview = $('.dealer-overview'),
            top = overview.find('h1'),
            bottom = overview.find('.dealer-list'),
            height = window.innerWidth > 760 ? window.innerHeight - top.outerHeight(true) : '';

        bottom.css('height', height);
    };

    DealerMap.prototype.showResults = function() {
        this.resultsVisible = true;
        $(this.settings.dealerResultsSelector).fadeIn(this.settings.fadeTime);
        var lookup = $(this.settings.dealerLookupSelector);
        if (lookup[0].style.display != 'none') {
            lookup.fadeOut(this.settings.fadeTime);
        }
        var overlay = $(this.settings.overlaySelector);
        if (overlay[0].style.display != 'none') {
            overlay.fadeOut(this.settings.fadeTime);
        }

        this.mapContainer.addClass('maps-open');
        this.fixResultLayout();
    };

    DealerMap.prototype.hideResults = function() {
        this.resultsVisible = false;
        $(this.settings.dealerResultsSelector).fadeOut(this.settings.fadeTime);
    };


    return DealerMap;
});

